import {forgetPasswordTypes} from "../AuthActionsTypes/ForgetPasswordActionsTypes";

export const setUserForgetPasswordError = error => {
    return {
        type: forgetPasswordTypes.SET_ERROR,
        name: forgetPasswordTypes.UNKNOWN_ERROR,
        message: forgetPasswordTypes.UNKNOWN_ERROR_MESSAGE
    };
};

export const removeUserForgetPasswordErrors = error => {
    return {
        type: forgetPasswordTypes.REMOVE_ERRORS,
    };
};
